import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
import { DBCheckBoxObjective } from '_components';
import styles from './Common.module.css';
import { getAge } from '_helpers';

class SpecialTestLumbarInstabilityCPRAgeLT40 extends React.Component {

    componentDidMount() {
        if( this.props.ageLt40 === null && this.props.age < 40 ) {
            this.props.updateBitField(this.props.noteId, 'PTOBJECTIVESPECTESTS', 'TSNO', this.props.tsno, 'TSLINSAGELT40', true);

        }
    }

    render() {
        return (
            <div className={styles.textfield_row}>
                <span className={styles.flag} />
                <span className={styles.spacer} />
                <label className={styles.label}>Age &lt; 40 years old</label>
                <span className={styles.r} />
                <DBCheckBoxObjective
                    noteId={this.props.noteId}
                    entity='PTOBJECTIVESPECTESTS'
                    entityKeyColumn='TSNO'
                    entityKeyValue={this.props.tsno}
                    field='TSLINSAGELT40'
                    disabled={true}
                    className={styles.checkbox_center}
                />
            </div>
        );
    }

}

function mapDispatchToProps(dispatch) {
    return {
        updateBitField: bindActionCreators(noteActions.updateBitField, dispatch)
    };
}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let tsno = parseInt(Object.keys(state.entities.notes.PTOBJECTIVESPECTESTS)
        .find(key => (state.entities.notes.PTOBJECTIVESPECTESTS[key].TSEVNO === pk && noteType === 1)
            || (state.entities.notes.PTOBJECTIVESPECTESTS[key].TSNTNO === pk && noteType !== 1)));

    return {
        noteId: noteId,
        tsno: tsno,
        ageLt40: state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSLINSAGELT40,
        age: getAge(state.entities.patients[state.ui.patients.selectedPtno].dob)
    };
}

const connectedSpecialTestLumbarInstabilityCPRAgeLT40 = connect(mapStateToProps, mapDispatchToProps)(SpecialTestLumbarInstabilityCPRAgeLT40);
export { connectedSpecialTestLumbarInstabilityCPRAgeLT40 as SpecialTestLumbarInstabilityCPRAgeLT40 };


